import React, { useState, useRef } from 'react';

const GraficPizza = ({ data, title }) => {
  const chartData = data.filter(item => item.label !== 'Visitas Hoje');
  //const chartData = data.filter(item => item.label);
  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  let cumulativePercent = 0;

  const [tooltip, setTooltip] = useState({ show: false, label: '', x: 0, y: 0 });
  const svgRef = useRef();

  const handleMouseMove = (e, item) => {
    const rect = svgRef.current.getBoundingClientRect();
    setTooltip({
      show: true,
      label: `${item.label}: ${item.value}`,
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ show: false, label: '', x: 0, y: 0 });
  };

  return (
    <div style={{ maxWidth: '300px', margin: '0 auto', textAlign: 'center', position: 'relative' }}>
      <svg
        ref={svgRef}
        viewBox="0 0 100 100"
        style={{ width: '100%', height: 'auto' }}
      >
        {chartData.map((item, index) => {
          const percent = item.value / total;
          const startX = 50 + 40 * Math.cos(2 * Math.PI * cumulativePercent);
          const startY = 50 + 40 * Math.sin(2 * Math.PI * cumulativePercent);
          cumulativePercent += percent;
          const endX = 50 + 40 * Math.cos(2 * Math.PI * cumulativePercent);
          const endY = 50 + 40 * Math.sin(2 * Math.PI * cumulativePercent);
          const largeArcFlag = percent > 0.5 ? 1 : 0;

          return (
            <path
              key={index}
              d={`M 50 50 L ${startX} ${startY} A 40 40 0 ${largeArcFlag} 1 ${endX} ${endY} Z`}
              fill={item.color}
              onMouseMove={(e) => handleMouseMove(e, item)}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer' }}
            />
          );
        })}
        <circle cx="50" cy="50" r="25" fill="white" />
        <text x="50" y="50" textAnchor="middle" dy=".3em" fontSize="8" fill="#333">
          {title || 'Unidade'}
        </text>
      </svg>

      {tooltip.show && (
        <div style={{
          position: 'absolute',
          top: tooltip.y,
          left: tooltip.x,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          padding: '6px 10px',
          borderRadius: '5px',
          pointerEvents: 'none',
          fontSize: '12px',
          transform: 'translate(-50%, -120%)',
          whiteSpace: 'nowrap',
          zIndex: 10
        }}>
          {tooltip.label}
        </div>
      )}

      <div style={{ marginTop: '20px' }}>
        {data.map((item, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            margin: '8px 0',
            justifyContent: 'center'
          }}>
            <div style={{
              width: '15px',
              height: '15px',
              backgroundColor: item.color,
              marginRight: '10px',
              borderRadius: '3px'
            }}></div>
            <span style={{ fontSize: '14px' }}>
              <strong>{item.value}</strong> - {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GraficPizza;